import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useScrollToTop } from "@/hooks/use-scroll-to-top";
import { useEffect } from "react";
import { initGTM } from "@/lib/analytics";
import Home from "@/pages/home";
import HowItWorks from "@/pages/howitworks";
import ProjectFormPage from "@/pages/project-form";
import About from "@/pages/about";
import FAQ from "@/pages/faq";
import Blog from "@/pages/blog";
import BlogPostPage from "@/pages/blog-post";
import AdminBlog from "@/pages/admin-blog";
import NotFound from "@/pages/not-found";

function Router() {
  useScrollToTop();
  
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/howitworks" component={HowItWorks} />
      <Route path="/project-form" component={ProjectFormPage} />
      <Route path="/about" component={About} />
      <Route path="/faq" component={FAQ} />
      <Route path="/blog" component={Blog} />
      <Route path="/blog/:slug" component={BlogPostPage} />
      <Route path="/admin/blog" component={AdminBlog} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  useEffect(() => {
    // Initialize GTM tracking enhancement
    const initializeTracking = () => {
      try {
        initGTM();
        console.log('GTM tracking initialized');
      } catch (error) {
        console.error('Tracking initialization error:', error);
      }
    };

    // Initialize after DOM is ready
    const timer = setTimeout(initializeTracking, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
